import React from 'react';
import { Flex } from 'rebass';
import Layout from '@/components/Layout';
import { MainColumn } from '@/components/Layout/ThirdPaneLayout';
import PageBar from '@/components/PageBar/PageBar';
import { MyAccountSection, SecuritySection } from '@/components/Security';

const AdminProfile = (): JSX.Element => (
  <Layout>
    <MainColumn px="mainContent" pb="mainContent" height="inherit">
      <PageBar title="Profile" />
      <Flex flexDirection="column" maxWidth={600}>
        <MyAccountSection />
        <SecuritySection />
      </Flex>
    </MainColumn>
  </Layout>
);

export default AdminProfile;
